import '../assets/styles/login.scss';
import { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import Button from '../components/common/Button';
import { TextField } from '../components/common/Input';
import Timer from '../components/common/Timer';
import { useLocation, useNavigate } from 'react-router';

export default function Verification() {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, signIn } = useContext(AuthContext);
  const { state } = useLocation();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [code, setCode] = useState('');
  const [resetKey, setResetKey] = useState(0);
  const [remainingTime, setRemainingTime] = useState(-1);
  const [errMsg, setErrMsg] = useState('');
  const [certKey, setCertKey] = useState('');
  const [attemptCount, setAttemptCount] = useState(1);

  function requestVerificationCode() {
    if (phoneNumber.length < 11) {
      setErrMsg('휴대폰 번호를 입력해주세요.');
      return;
    }
    setErrMsg('');
    setCode('');
    fetch(`${API_SERVER_DOMAIN}/auth/cert/send`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${state.accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        telNo: phoneNumber,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.result === 'ok') {
          setRemainingTime(3);
          setCertKey(data.key);
          setAttemptCount(1);
        } else {
          setErrMsg(data.msg);
        }
      });
  }

  function verifyCode() {
    if (code.length < 6) {
      setErrMsg('인증 코드를 입력해주세요.');
      return;
    }
    fetch(`${API_SERVER_DOMAIN}/auth/cert`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${state.accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        key: certKey,
        code: code,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.result === 'ok') {
          // 인증 성공
          localStorage.setItem('isVerified', 'Y');
          if (state.redirectTo) {
            navigate(state.redirectTo);
          } else {
            signIn(state.accessToken, state.accessTokenExpiresIn, state.refreshToken);
          }
        } else if (attemptCount >= 3) {
          setResetKey(resetKey + 1);
          setRemainingTime(-1);
          setCertKey('');
          setAttemptCount(1);
          setErrMsg('인증코드 입력을 3번 실패하였습니다.\n휴대폰 번호를 다시 입력해 주세요.');
        } else {
          setErrMsg(data.msg + `\n실패 횟수: ${attemptCount}`);
          setAttemptCount((prev) => prev + 1);
        }
      });
  }

  function onTimerEnd() {
    setResetKey(resetKey + 1);
    setRemainingTime(0);
    setCertKey('');
    setAttemptCount(1);
  }

  return (
    <section className="verification-page">
      <p className="verification-desc">
        로그인 시 본인 확인을 위해
        <br />
        추가적으로 휴대폰 인증을 하고 있습니다.
      </p>
      <p className="verification-desc">인증 버튼을 클릭하여 인증 코드를 확인하세요.</p>

      <div className="verification-phone-number">
        <TextField
          key={resetKey}
          placeholder="휴대폰 번호"
          error={errMsg && attemptCount === 1}
          onChange={setPhoneNumber}
          maxLength={13}
        />
        <Button onClick={requestVerificationCode}>인증</Button>
      </div>

      <div className="verification-code">
        <TextField
          key={resetKey + 1}
          placeholder="인증 코드"
          error={attemptCount > 1}
          onChange={setCode}
          maxLength={8}
        />
      </div>

      {remainingTime >= 0 && (
        <div className="timer">
          <Timer minute={remainingTime} onEnd={onTimerEnd} />
          {!errMsg && (
            <p className="timer-desc">
              {remainingTime > 0
                ? '인증코드가 발송되었습니다. 휴대폰 메시지를 확인해주세요.'
                : '입력시간이 만료되었습니다.\n휴대폰 번호를 다시 입력해 주세요.'}
            </p>
          )}
        </div>
      )}

      {errMsg && <div className="error-msg">{errMsg}</div>}

      <Button disabled={remainingTime <= 0} className="confirmation" onClick={verifyCode}>
        확인
      </Button>
    </section>
  );
}
